// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"98e490f7","865":"0bad1e71"}[chunkId] + ".chunk.css";
};